import * as yup from 'yup';

import localization from 'localization';

import commonPasswords from './commonPasswords';

const PASS_MIN_CHAR = 10;

const getPasswordError = () => {
  const i18n = localization.cloneInstance();

  return i18n.t('Password must be at least 6 characters');
};

const getPasswordError2 = () => {
  const i18n = localization.cloneInstance();

  return i18n.t(`Password must be at least ${PASS_MIN_CHAR} characters`);
};

const getCommonPasswordError = () => {
  const i18n = localization.cloneInstance();

  return i18n.t(
    'The password you created is unfortunately too common. For added security, try making it longer or adding special characters.'
  );
};

const validatePasswordV2 = yup
  .string()
  .trim()
  .min(PASS_MIN_CHAR, getPasswordError2)
  .required()
  .notOneOf(commonPasswords, getCommonPasswordError);

/**
 * Use the new password validation schema.
 * @deprecated
 */
const validatePasswordV1 = yup
  .string()
  .trim()
  .min(6, getPasswordError)
  .required();

export {
  validatePasswordV1,
  validatePasswordV2,
  getPasswordError,
  getPasswordError2,
  getCommonPasswordError,
};
